import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/clients/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}clients/delete`,
        endpoint: config.endpoints.backend + 'clients/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : {},
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Clientes',
        labelTitleButtonAdd: 'Incluir novo cliente',
        fieldsShowOnDelete: ['client_name'],
        showPrintButtons: true,
        formFilters: filters,
        filter: {
            ...profileFilter,
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'client_name',
                label: 'Nome'
            },
            {
                name: 'documento',
                label: 'Documento'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            },
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
